module.exports = __webpack_public_path__ + "static/sport/bgi-form-h5.c8c62c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-sport/bgi-form-h5.png
// module id = D4no
// module chunks = 0